import React from "react";
import { updateConfig } from "State/Admin/AdminSettings/ConfigurationSlice";
import { useAppDispatch, useAppSelector } from "hooks";
import { RootState } from "State/store";

const ReturnSettings: React.FC = () => {
  const dispatch = useAppDispatch();
  const config = useAppSelector((state: RootState) => state.configuration.config);

  return (
    <div className="font-body tracking-wider bg-white p-4 rounded-md border border-gray-200">
      <h4 className="text-xs font-medium text-gray-700 mb-3">
        Return Settings
      </h4>
      <div className="space-y-3">
        <div className="flex items-center">
          <input
            id="return_enabled"
            type="checkbox"
            checked={config.isReturnEnabled ?? false}
            onChange={() => dispatch(updateConfig({ isReturnEnabled: !config.isReturnEnabled }))}
            className="h-3 w-3 text-blue-600 focus:ring-blue-500 border-gray-300"
          />
          <label
            htmlFor="return_enabled"
            className="ml-2 block text-xs text-gray-700"
          >
            Enable Return
          </label>
        </div>

        {config.isReturnEnabled && (
          <div>
            <label
              htmlFor="return_days"
              className="block text-xs font-medium text-gray-700 mb-1"
            >
              Return Days
            </label>
            <input
              id="return_days"
              type="number"
              min="1"
              onWheel={(e) => e.currentTarget.blur()}
              value={config.returnDays ?? 0}
              onChange={(e) => dispatch(updateConfig({ returnDays: parseInt(e.target.value) || 0 }))}
              className="block w-full text-xs border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ReturnSettings;
